import React, { Component } from "react";
import { Slider } from "antd";

class LiabilitiesRatio extends Component {
	constructor(props) {
		super(props);
		this.state= {
			x: (this.props.query===undefined || this.props.query["liabilities"]===undefined) ? [-1,1]: this.props.query["liabilities"].split('<=liabilities_ratio; liabilities_ratio<=').map(Number),
    	}
    	this.formatQueryRange(this.state.x);
  	}

	formatVal(value){
		// format tooltip for liabilities slider
		return `${value}`;
	}
	formatQueryRange(value){
		let formattedVal = value.join('<=liabilities_ratio; liabilities_ratio<=');
		this.props.buildSearchQuery('liabilities', formattedVal);
	}
	render() {
		const marks = {
			'-1': '-100%',
			'1': '100%'
		}
		return (
			<section>
				<p className="panel-section-header">
					{this.props.queryTypeSingular}'s Liabilities Ratio
				</p>
				<div>
					<Slider
						range
						marks={marks}
						step={0.01}
						min={-1}
						max={1}
						tipFormatter={this.formatVal.bind(this)}
						defaultValue={this.state.x}
						onChange={this.formatQueryRange.bind(this)}
					/>
				</div>
			</section>
		);
	}
}

export default LiabilitiesRatio;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/AcquireesOptions/LiabilitiesRatio/LiabilitiesRatio.js